/**
 * Bridge between axios (no Redux) and auth state when consent middleware returns 403.
 */
let consentGateHandler = null;

export function registerConsentGateHandler(handler) {
  consentGateHandler = handler;
}

export function triggerConsentGate(payload) {
  if (typeof consentGateHandler === "function") {
    consentGateHandler(payload);
  }
}

export function isConsentRequiredResponse(error) {
  const data = error?.response?.data;
  return error?.response?.status === 403 && data?.consentRequired === true;
}
